/** @jsx jsx */
import { useDirection } from '@front10/utils';
import { useState } from 'react';
import { jsx, Styled } from '../types';
import ICONS from './icons';

export type IconName = typeof ICONS[number]['name'];
export type IconData = typeof ICONS[number];

interface Props {
  icon?: IconName;
  animation?: 'mirror' | 'infinite';
  size?: number | number[];
  paths?: string[];
  viewBox?: string;
  rtlFlip?: boolean;
  className?: string;
}

// TODO: Fix svgPaths
const renderPaths = (iconData: IconData | undefined, svgPaths: string[]) => {
  const paths = svgPaths.length === 0 ? iconData?.paths : svgPaths;
  if (paths) {
    // eslint-disable-next-line react/no-array-index-key
    return (paths as string[]).map((item: string, key: number) => <path key={key} d={item} />);
  }
  return null;
};

export type IconProps = Styled<Props & Omit<JSX.IntrinsicElements['svg'], 'ref'>>;

export function Icon({
  icon = 'broken-heart',
  animation,
  size = 16,
  viewBox,
  fill = 'currentColor',
  paths = [],
  rtlFlip = false,
  style,
  className,
  sx,
  ...props
}: IconProps) {
  const [aniActive, setAnimationActive] = useState(false);
  let classNameRotate = '';
  if (animation) {
    if (animation !== 'infinite' && aniActive) {
      classNameRotate = `fr-icon-animation-${animation}-active`;
    } else {
      classNameRotate = `fr-icon-animation-${animation}`;
    }
  }
  const rotateIcon = () => {
    setAnimationActive(!aniActive);
  };
  const classIcons = `fr-icon fr-icon-${icon} ${classNameRotate}`;
  const direction = useDirection();

  const iconData = paths.length === 0 ? ICONS.find((item) => item.name === icon) : undefined;
  let resolvedViewBox = viewBox;
  // @ts-ignore
  if (!resolvedViewBox && iconData && iconData!.viewBox) {
    // @ts-ignore
    resolvedViewBox = iconData.viewBox;
  } else {
    resolvedViewBox = '0 0 1024 1024';
  }

  return (
    <svg
      onClick={() => animation !== 'infinite' && rotateIcon()}
      className={`${classIcons} ${className}`}
      style={style}
      viewBox={resolvedViewBox}
      sx={{
        width: size,
        height: size,
        transform: rtlFlip && direction === 'rtl' ? 'scaleX(-1)' : undefined,
        fill,
        ...sx
      }}
      {...props}
    >
      {renderPaths(iconData, paths)}
    </svg>
  );
}

Icon.componentName = 'Icon';
